export const ACCOUNT_STATUS = {
  PENDING_VERIFICATION: 'pending_manual_verification',
  LOGIN_REQUIRED: 'item_login_required',
  PENDING_EXPIRATION: 'pending_expiration',
};
